// app/javascript/modules/admissoes/adiantamento.js
//
// Checkbox:  #params_tem_adiantamento
// Input:     #params_percentual_adiantamento
//
// Regra:
// - desmarcado: desabilita + readonly + limpa + visual "cinza"
// - marcado: habilita + remove visual "cinza"

export function initAdiantamento($form, h) {
  const { clearValue } = h
  if (!$form || !$form.length) return { destroy() { } }

  const $chk = $form.find("#params_tem_adiantamento").first()
  const $pct = $form.find("#params_percentual_adiantamento").first()

  if (!$chk.length || !$pct.length) return { destroy() { } }

  function apply() {
    const checked = $chk.is(":checked")

    $pct.prop("disabled", !checked)
    $pct.prop("readonly", !checked)

    if (!checked) {
      clearValue("#params_percentual_adiantamento")
      $pct.addClass("bg-gray-100 text-gray-500")
    } else {
      $pct.removeClass("bg-gray-100 text-gray-500")
    }
  }

  // impede digitação quando estiver travado
  $pct.off("keydown.admAdianta paste.admAdianta")
    .on("keydown.admAdianta paste.admAdianta", function (e) {
      if ($pct.is(":disabled") || $pct.is("[readonly]")) {
        e.preventDefault()
        return false
      }
    })

  $chk.off("change.admAdianta").on("change.admAdianta", apply)

  apply()

  return {
    destroy() {
      $chk.off(".admAdianta")
      $pct.off(".admAdianta")
    },
  }
}
